export default class LogUser   {

    constructor(obj){
        this.LOGID=obj.LOGID;
        this.LOGName=obj.LOGNAME;
        this.LOGEMail=obj.LOGEMAIL;
        this.LOGPswd=obj.LOGPSWD;
        this.LOGRole=obj.LOGROLE;
        this.LOGAvatar=obj.LOGAVATAR;
        this.LOGPrevLog=obj.LOGPREVLOG;
        this.LOGLastLog=obj.LOGLASTLOG;
    }

}